import React, { useState } from 'react';
import SimpleCheckBox from '../../../components/checkbox/check';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Api from 'src/services/api';
import * as componentActions from '../.././../redux/actions/configs';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl'

const ConfigArticles = (props) => {
  const [enableTagsOnArticles, setEnableTagsOnArticles] = useState(props.initialValueEnableTagsOnArticles ? props.initialValueEnableTagsOnArticles : false);
  const intl = props.intl;


  const handleSubmit = async (e) => {
    e.preventDefault();


    props.setLoading(true)

    let data = {
      enableTagsOnArticles: enableTagsOnArticles,
      configId: props.configId

    };

    Api.put('/configarticles', data)
      .then((result) => {
        if (result.data.success) {

          props.setLoading(false)
          props.setMessage(true, 'success', 'Registro atualizado com sucesso')
          props.updatedConfigArticles(enableTagsOnArticles)

        } else {

          props.setLoading(false)
          props.setMessage(true, 'error', result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))


        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          props.setLoading(false)
          props.setMessage(true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))
        }
        else {
          props.setLoading(false)
          props.setMessage(true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }) + err.response.data)
        }
      });

  }

  return (
    <div>
      <SimpleCheckBox
        label={intl.formatMessage({ id: 'enable.tags.on.articles' })}
        name='enableTagsOnArticles'
        stateName='enableTagsOnArticles'
        changeSelect={(stateName, value) => {
          setEnableTagsOnArticles(value)
          props.handleCheckboxChange(stateName, value)
        }
        }
        selected={enableTagsOnArticles}
      />

      <Grid container style={{ marginTop: '25px' }}>
        <Grid item xs={4} />
        <Grid item xs={4} />
        <Grid item xs={4} container alignItems="flex-end" justifyContent="flex-end">
          <Button variant="contained" color="primary" type="submit" fullWidth onClick={handleSubmit}>
            Salvar
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};


const mapStateToProps = state => ({
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  configs: state.configs,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ConfigArticles))
